export default __webpack_public_path__ + "static/media/pic2.11c4972a.jpg";